import { useState } from "react";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import prescreeningTemplateApi, {
  PrescreeningTemplate,
  GetPrescreeningTemplatesResponse
} from "api/landlord/prescreeningTemplates";

export const usePrescreeningTemplatesController = (perPage: number = 999) => {
  const [currentPage, setCurrentPage] = useState(1);

  const defaultTemplateQuery = useQuery<PrescreeningTemplate>({
    queryKey: ["PRESCREENING_DEFAULT_TEMPLATE"],
    queryFn: () => prescreeningTemplateApi.getDefaultTemplate()
  });

  const templatesQuery = useQuery<GetPrescreeningTemplatesResponse>({
    queryKey: ["PRESCREENING_TEMPLATES", currentPage, perPage],
    queryFn: () => prescreeningTemplateApi.getTemplates(currentPage, perPage),
    placeholderData: keepPreviousData
  });

  return {
    defaultTemplate: defaultTemplateQuery.data,
    templates: templatesQuery.data?.items,
    isLoading: templatesQuery.isLoading,
    isFetching: templatesQuery.isFetching,
    refetchTemplates: templatesQuery.refetch,
    templatesData: templatesQuery.data,
    setCurrentPage
  };
};
